var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgPeople = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.703 6.563c-.114 1.588-1.293 2.812-2.578 2.812s-2.466-1.223-2.578-2.812c-.117-1.653 1.03-2.813 2.578-2.813 1.548 0 2.695 1.19 2.578 2.813Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 11.875c-2.546 0-4.994 1.264-5.607 3.727-.081.326.123.648.458.648h10.299c.335 0 .538-.322.458-.648-.614-2.502-3.062-3.727-5.608-3.727Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.812 7.264C7.721 8.532 6.77 9.53 5.742 9.53c-1.026 0-1.98-.998-2.07-2.267C3.578 5.944 4.505 5 5.742 5c1.237 0 2.164.968 2.07 2.264Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.047 11.954c-.705-.324-1.482-.448-2.305-.448-2.031 0-3.988 1.01-4.478 2.977-.065.26.098.517.366.517h4.386",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

export { SvgPeople as ReactComponent };